const ImageLoader = ({ loadedImages, setMetaData, selectedTemplates }) => {
    const getSelectedTemplateItem = (item) => {
        return selectedTemplates.length
            ? selectedTemplates.find(
                  (selected) => item.thumbnailUrl === selected.thumbnailUrl,
              )
            : false;
    };

    let arr = [];
    if (loadedImages.length) {
        loadedImages.forEach((item, i) => {
            item.index = i;

            let imageClass = "ImageLoaderImageContainer";

            const itemIsSelected = getSelectedTemplateItem(item);
            if (itemIsSelected)
                imageClass = "ImageLoaderImageContainerSelected";

            arr.push(
                <div className={imageClass} key={i}>
                    <img
                        className="ImageLoaderImageDisplayBrowse"
                        src={item.thumbnailUrl}
                        alt={item.title}
                        onLoad={() => {
                            imageClass = "ImageLoaderImageContainerDisplayNone";
                        }}
                        onClick={() => setMetaData(item)}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/imageNotFound.jpg";
                        }}
                        loading="lazy"
                    />
                </div>,
            );
        });
    }
    return <div className="ImageLoaderImageContainerContainer">{arr}</div>;
};

export default ImageLoader;
